export default {
  title: "Notifications",
  viewAll: "Tout voir",
  markAsRead: "Marquer comme lu",
  markAllAsRead: "Tout marquer comme lu",
  noNotifications: "Aucune notification",
  
  types: {
    info: "Information",
    warning: "Attention",
    error: "Erreur",
    success: "Succès"
  },
  
  actions: {
    view: "Voir",
    dismiss: "Ignorer",
    accept: "Accepter",
    decline: "Refuser"
  },

  categories: {
    system: "Système",
    tasks: "Tâches",
    guests: "Invités",
    budget: "Budget",
    vendors: "Prestataires",
    timeline: "Planning",
    achievements: "Succès",
    weddingWebsite: "Site Web Mariage"
  },
  
  settings: {
    title: "Paramètres de notification",
    push: {
      title: "Notifications Push",
      description: "Recevoir des notifications même sans utiliser l'application"
    },
    categories: {
      title: "Catégories de notification"
    },
    other: {
      title: "Autres notifications",
      email: {
        title: "Notifications par email",
        description: "Recevoir les mises à jour importantes par email"
      },
      desktop: {
        title: "Notifications de bureau",
        description: "Recevoir des notifications sur votre ordinateur"
      }
    },
    testButton: "Tester les notifications"
  },
  
  errors: {
    loadPreferences: "Erreur lors du chargement des préférences",
    pushToggle: "Erreur lors de la modification des notifications push",
    categoryToggle: "Erreur lors de la modification des catégories"
  }
};

